var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUser(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.5806 16.71L19.8206 17.85C20.048 18.8356 19.8235 19.8713 19.2082 20.6742C18.593 21.4771 17.6514 21.9633 16.6406 22H7.36058C6.34976 21.9633 5.40815 21.4771 4.79293 20.6742C4.17771 19.8713 3.95315 18.8356 4.18058 17.85L4.42058 16.71C4.69662 15.1668 6.0232 14.0327 7.59058 14H16.4106C17.978 14.0327 19.3045 15.1668 19.5806 16.71ZM16.6406 20.49C17.1484 20.4841 17.6263 20.2489 17.9406 19.85V19.86C18.3263 19.3762 18.4765 18.7458 18.3506 18.14L18.1106 17C17.9774 16.1552 17.2652 15.5226 16.4106 15.49H7.59059C6.73595 15.5226 6.02375 16.1552 5.89059 17L5.65059 18.14C5.52774 18.7426 5.67785 19.3687 6.06059 19.85C6.37492 20.2489 6.8528 20.4841 7.36059 20.49H16.6406Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.5006 12H11.5006C9.29143 12 7.50057 10.2092 7.50057 8.00001V5.36001C7.4979 4.46807 7.85104 3.61189 8.48175 2.98119C9.11245 2.35049 9.96863 1.99735 10.8606 2.00001H13.1406C14.0325 1.99735 14.8887 2.35049 15.5194 2.98119C16.1501 3.61189 16.5032 4.46807 16.5006 5.36001V8.00001C16.5006 10.2092 14.7097 12 12.5006 12ZM10.8606 3.50002C9.83332 3.50002 9.00057 4.33277 9.00057 5.36001V8.00001C9.00057 9.38073 10.1199 10.5 11.5006 10.5H12.5006C13.8813 10.5 15.0006 9.38073 15.0006 8.00001V5.36001C15.0006 4.86671 14.8046 4.39361 14.4558 4.0448C14.107 3.69598 13.6339 3.50002 13.1406 3.50002H10.8606Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUser);
export default __webpack_public_path__ + "static/media/User.c11ba848b074bd03513a9fe65911dc79.svg";
export { ForwardRef as ReactComponent };